import styled from "@emotion/styled";

export const Container = styled.div`
  position: absolute;
  z-index: 2;

  display: flex;

  inline-size: 100%;
  block-size: 100%;
`;

export const SwipeRightArea = styled.div`
  inline-size: 75%;
`;

export const SwipeLeftArea = styled.div`
  inline-size: 25%;
`;
